firebird.factory('videoStatsFrozenService', [
    '$rootScope',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'helperService',
    'analyticsWrapperService',
    'videoGlobalService',
    'localizationService',
    'configService',
    'storageService',
    function (
        $rootScope,
        $timeout,
        $interval,
        $window,
        logService,
        helperService,
        analyticsWrapperService,
        videoGlobalService,
        localizationService,
        configService,
        storageService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoStatsFrozenService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initStatsFrozen = initStatsFrozen;

            // config using brokenMediaPath flag.

            self.brokenMediaPath = {
                detect: true,
                restart: false,
                duration: 0 // if positive then within that interval. otherwise, any full interval.
            };
            self.onBrokenMediaPathCheck = onBrokenMediaPathCheck;
            self.onBrokenMediaPathDetected = onBrokenMediaPathDetected;
            self.setBrokenMediaPathConfig = setBrokenMediaPathConfig;

            // config using frozenWorkaround flag.

            self.onFrozenVideoTxCheck = onFrozenVideoTxCheck;
            self.onFrozenVideoTxDetected = onFrozenVideoTxDetected;
            self.onFrozenVideoTxStop = onFrozenVideoTxStop;

            self.onFrozenVideoRxCheck = onFrozenVideoRxCheck;
            self.onFrozenVideoDetected = onFrozenVideoDetected;
            self.onFrozenVideoRxUpdate = onFrozenVideoRxUpdate;

            self.frozenWorkaround = {
                stopVideoTx: false, // if set to true then stop webcam (video-tx).
                logVideoTx: true, // whether to log frozen detection
                txIntervalCount: 1, // how many intervals to wait before taking above action.
                txThreshold: 1, // if framerate goes below (<=) this number.
                onlyCustomStream: false, // previous condition only if custom stream is used.
                captureCheck: true, // if set to true then check for fpsCapture, and restart publish if 0.
                restartVideoRx: false, // if set to true then resubscribe after interval count is reached for video-rx.
                rxIntervalCount: 3, // how many intervals to wait before taking above action.
                frozenStats: false // enable quick stats (see frozenStats below) to quickly recover to hide avatars.
            };
            self.frozenCapture = true; // whether webcam capture framerate is positive yet, only used if captureCheck is set.

            self.setFrozenWorkaroundConfig = setFrozenWorkaroundConfig;

            self.disableFrozenWorkaroundOnChrome109 = false; // workaround is not needed anymore.

            // if frozenWorkaround flag has frozenStats set, then enable this workaround.

            self.frozenStats = {
                items: {}, // fid to {state:enum(idle,checking,frozen,[playing]), playing:bool, list:[], interval:..., pending:bool}
                duration: 1000 //duration for metric collection timer
            };

            self.setVideoStatsAddRemove = setVideoStatsAddRemove;
            self.setVideoStatsStart = setVideoStatsStart;
            self.setVideoStatsState = setVideoStatsState;
            self.setVideoStatsPlaying = setVideoStatsPlaying;
            self.setVideoStatsFrozen = setVideoStatsFrozen;
            self.onVideoStatsInterval = onVideoStatsInterval;
            self.onVideoStatsVerify = onVideoStatsVerify;
            self.resetVideoStats = resetVideoStats;

            // moved from videoPlayService
            self.checkMuteToFIR = checkMuteToFIR;
            self.removeMuteToFIR = removeMuteToFIR;
            self.onTimeoutMuteToFIR = onTimeoutMuteToFIR;
            self.getReceivedBytesAndFrames = getReceivedBytesAndFrames;
            self.canAnalyzeStatsReportMetric = canAnalyzeStatsReportMetric;
            self.getPeerConnectionStats = getPeerConnectionStats;
            self.getAudioPeerConnectionStats = getAudioPeerConnectionStats;
            self.getVideoroomPeerConnectionStats = getVideoroomPeerConnectionStats;
            self.applyFakePeerConnectionStats = applyFakePeerConnectionStats;
            self.shouldRejoinConference = shouldRejoinConference;
            self.validateBytesReceived = validateBytesReceived;
            self.validateAvailableOutgoingBitrate = validateAvailableOutgoingBitrate;
            self.validateFramesEncoded = validateFramesEncoded;
            self.validatePacketsLost = validatePacketsLost;
            self.validateRtt = validateRtt;

            self.timeoutMuteToFIR = 6000; // after 6s of mute, if no frames were decoded, but bytes were received, trigger keyframe request.
            self.maxRetryMuteToFIR = 10; // will try at most 10 times to send keyframe.

            // detect missing media source, and prompt user.
            self.brokenMediaSource = {
                detect: true,
                prompted: false,
                detected: false
            };
            self.onBrokenMediaSourceCheck = onBrokenMediaSourceCheck;

            // overloads config and version check
            self.fixFrozenOn115 = helperService.getChromeVersion() >= 115;
        }

        // update state from config.
        function initStatsFrozen() {
            // frozenWorkaround
            self.setFrozenWorkaroundConfig(configService.getValue('frozenWorkaround'));

            self.brokenMediaSource.detect = configService.getValue('brokenMediaSource') != 'false';

            // brokenMediaPath workaround
            self.setBrokenMediaPathConfig(configService.getValue('brokenMediaPath'));

            var timeoutMuteToFIR = configService.getValue('timeoutMuteToFIR');
            self.timeoutMuteToFIR =
                timeoutMuteToFIR && timeoutMuteToFIR.match(/^\d+$/) ? parseInt(timeoutMuteToFIR) || 0 : 6000; // default 6000, but allows setting to 0.

            self.fixFrozenOn115 =
                helperService.getChromeVersion() >= 115 && configService.getValue('fixFrozenOn115') !== 'false';
        }

        // called from stats to check
        function onBrokenMediaPathCheck(type, item1, interval, interval0) {
            if (!self.brokenMediaPath.detect) {
                return;
            }
            var videoPlugin = type == 'screen' ? self.screenshare : self.videoroom;
            if (item1.candidateChanges > 0) {
                videoPlugin._lastCandidateChangeTime = Date.now(); // not accurate, but of end of stats interval.
            } else if (
                interval0 == interval &&
                item1.bytesSent > 0 &&
                item1.framesSent > 0 &&
                item1.bytesReceivedNetwork === 0 &&
                (!self.brokenMediaPath.duration ||
                    Date.now() <= videoPlugin._lastCandidateChangeTime + self.brokenMediaPath.duration * interval)
            ) {
                // within 1.5 intervals.
                self.onBrokenMediaPathDetected(type, 'no rx bytes on tx connection');
            }
        }

        // when broken ICE path detected on full 10s stats interval.
        function onBrokenMediaPathDetected(type, reason) {
            logger.warn('onBrokenMediaPathDetected', 'broken media path after candidate switch detected', type, reason);
            $timeout(function () {
                // republish if needed.
                var data = { sfuEvent: true, type: type, id: self.attendantId, restart: self.brokenMediaPath.restart };
                self.msgflowEvent('broken-media-path', {
                    type: type,
                    reason: reason,
                    restart: self.brokenMediaPath.restart
                });
                analyticsWrapperService.eventTrack('Meeting - broken media path detected', data);
                if (self.brokenMediaPath.restart) {
                    self.onRestartVideoPublish(undefined, type == 'screen'); // takes care of corner cases too.
                }
            }, 0);
        }

        function setBrokenMediaPathConfig(brokenMediaPath) {
            if (brokenMediaPath == 'false') {
                self.brokenMediaPath.detect = self.brokenMediaPath.restart = false;
            } else if (brokenMediaPath == 'true') {
                self.brokenMediaPath.detect = self.brokenMediaPath.restart = true;
            } else {
                // default is detect but not restart
                self.brokenMediaPath.detect = true;
                self.brokenMediaPath.restart = false;
                self.brokenMediaPath.duration = 0;
                if (brokenMediaPath) {
                    self.setConfigObjectFromCSV(self.brokenMediaPath, brokenMediaPath);
                }
            }
        }

        // called from stats to check.
        function onFrozenVideoTxCheck(item1, frameRate) {
            if (
                self.videoroom &&
                self.frozenWorkaround.captureCheck &&
                self.frozenCapture &&
                item1.fpsCapture > 0 &&
                (!self.fixFrozenOn115 || item1.fpsCapture > 1)
            ) {
                self.frozenCapture = false; // no longer frozen webcam capture
            }

            if (self.videoroom && !self.republishing && frameRate <= self.frozenWorkaround.txThreshold) {
                var frozenData = {
                    frameRate: frameRate,
                    framesEncoded: item1.framesEncoded,
                    framesSent: item1.framesSent,
                    fpsCapture: item1.fpsCapture,
                    customStream: self.videoroom && self.videoroom.hasCustomStream
                };

                if (self.frozenWorkaround.logVideoTx) {
                    self.onFrozenVideoTxDetected(frozenData);
                }

                if (
                    self.frozenWorkaround.stopVideoTx &&
                    (!self.frozenWorkaround.onlyCustomStream || frozenData.customStream)
                ) {
                    if (self.videoroom.state) {
                        self.videoroom.state.frozenCount = (self.videoroom.state.frozenCount || 0) + 1;
                    }
                    if (
                        self.videoroom.state &&
                        self.videoroom.state.frozenCount >= self.frozenWorkaround.txIntervalCount
                    ) {
                        if (
                            self.frozenWorkaround.captureCheck &&
                            self.videoroom.state.frozenCount === 1 &&
                            !self.frozenCapture &&
                            frozenData.fpsCapture !== undefined &&
                            (frozenData.fpsCapture === 0 || (frozenData.fpsCapture === 1 && self.fixFrozenOn115))
                        ) {
                            self.frozenCapture = true; // so next time it won't come here.
                            logger.error(
                                'onFrozenVideoTxCheck',
                                'restarting webcam, as capture framerate is low or 0',
                                frozenData
                            );
                            $timeout(function () {
                                self.republishing = true;
                                self.stopVideoPublish();
                                self.startVideoPublish();
                            });
                        } else {
                            delete self.videoroom.state.frozenCount;
                            logger.error(
                                'onFrozenVideoTxCheck',
                                'disabling webcam, as framerate is low or 0',
                                frozenData
                            );
                            $timeout(function () {
                                self.onFrozenVideoTxStop(frozenData);
                            });
                        }
                    }
                } else {
                    if (self.videoroom.state && self.videoroom.state.frozenCount !== undefined) {
                        delete self.videoroom.state.frozenCount;
                    }
                }
            } else {
                if (self.videoroom && self.videoroom.state && self.videoroom.state.frozenCount !== undefined) {
                    delete self.videoroom.state.frozenCount;
                }
            }
        }

        // called from stats to check
        function onFrozenVideoRxCheck(item1, item2, detect, indexId, index1, decodeTime) {
            var frozenReason = null;
            if (!item2.paused && (!self.layoutPage || !item2.disabled)) {
                if (item1.framesDecoded === 0) {
                    frozenReason = item1.bytesReceived ? 'no frames' : 'no bytes';
                    if (detect) {
                        // log only for msgflow interval, not stats display.
                        if (!self.isScreenshareId(parseInt(indexId))) {
                            // TODO: does not work with refactorPublisherId.
                            self.setVideoStatsFrozen(indexId);
                        }
                        self.onFrozenVideoDetected({
                            from: index1,
                            name: item2.displayname,
                            codec: item1.videocodec || 'default',
                            bytes: item1.bytesReceived
                        });
                    }
                }

                if (item1.framesDecoded > 5 && decodeTime < 0.01) {
                    // less than 0.1ms per frame. assume problem or hardware decode.
                    if (item1.frameWidth && item1.frameHeight && item1.frameWidth > 180 && item1.frameHeight > 180) {
                        // but only if more than 180p.
                        frozenReason = 'no decode';
                    }
                }
            }
            return frozenReason;
        }

        function onFrozenVideoRxUpdate(feed, frozenReason, detect, indexId, item1) {
            var oldValue = feed.state.frozen;
            if (frozenReason) {
                feed.state.frozen = frozenReason;
            } else {
                if (feed.state.frozen) {
                    delete feed.state.frozen;
                }
            }

            if (detect) {
                // only for msgflow interval 10s
                if (frozenReason) {
                    if (oldValue != frozenReason) {
                        self.msgflowEvent('frozen:video-rx', { feed: indexId, reason: frozenReason });
                    }
                }

                if (frozenReason && item1.framesDecoded === 0) {
                    feed.state.frozenCount = (feed.state.frozenCount || 0) + 1;

                    if (
                        (!self.fixScreenOn115 || !feed.isScreen) &&
                        self.frozenWorkaround.restartVideoRx &&
                        feed.state.frozenCount >= self.frozenWorkaround.rxIntervalCount
                    ) {
                        logService.log(
                            'videoroomCtrl - restart video play for ' +
                                indexId +
                                ' as frozenCount=' +
                                feed.state.frozenCount +
                                ' reached threshold'
                        );
                        delete feed.state.frozenCount;
                        $timeout(function () {
                            // avoid blocking the stats thread.
                            analyticsWrapperService.eventTrack(
                                'Meeting - frozen video restarting',
                                Object.assign({ sfuEvent: true }, { viewer: self.attendantId + '', publisher: indexId })
                            );
                            self.onRestartVideoPlay(indexId);
                        });
                    }
                } else {
                    if (feed.state.frozenCount) {
                        delete feed.state.frozenCount;
                    }
                }
            }
        }

        // log frozen video detection
        function onFrozenVideoDetected(data) {
            logger.warn('onFrozenVideoDetected', 'frozen video detected', data);

            data.sfuEvent = true;
            $timeout(function () {
                // avoid blocking the stats callback, when the network condition may be poor.
                analyticsWrapperService.eventTrack('Meeting - frozen video detected', data);
            }, 0);
        }

        function onFrozenVideoTxDetected(data) {
            self.msgflowEvent('frozen:video-tx', data);
            $timeout(function () {
                analyticsWrapperService.eventTrack(
                    'Meeting - frozen video detected on publish',
                    Object.assign({ sfuEvent: true }, data)
                );
            }, 0);
        }

        function onFrozenVideoTxStop(frozenData) {
            $rootScope.$broadcast('stop-sfu-videopublish');
            var title = localizationService.translate('COMMON.OOPS_TEXT');
            var content = frozenData.customStream
                ? localizationService.translate('DIALOG.STOP_PUBLISH_LOW_FPS_VBG')
                : localizationService.translate('DIALOG.STOP_PUBLISH_LOW_FPS');
            var okText = frozenData.customStream
                ? localizationService.translate('COMMON.TURN_OFF')
                : localizationService.translate('COMMON.OK_TEXT');
            var cancelText = localizationService.translate('COMMON.CANCEL_TEXT');
            if (frozenData.customStream) {
                self.showAlert(
                    title,
                    content,
                    false,
                    function (confirmed) {
                        //turn off vbg
                        if (confirmed) {
                            storageService.remove('virtual-background-id');
                            storageService.remove('videoFilter');
                        }
                    },
                    { okText: okText, cancelText: cancelText }
                );
            } else {
                self.showAlert(title, content, false, null, { okText: okText });
            }
        }

        function setFrozenWorkaroundConfig(frozenWorkaround) {
            // 'true' or 'false' or comma separated name:value format like 'onlyCustomStream:true,txIntervalCount:1,rxIntervalCount:3'
            if (frozenWorkaround && frozenWorkaround != 'false') {
                self.frozenWorkaround.stopVideoTx =
                    self.frozenWorkaround.restartVideoRx =
                    self.frozenWorkaround.frozenStats =
                        true;
                self.frozenWorkaround.captureCheck = true;
                self.setConfigObjectFromCSV(self.frozenWorkaround, frozenWorkaround);

                if (self.disableFrozenWorkaroundOnChrome109 && self.isGetStatsTrackMetricDeprecated) {
                    self.frozenWorkaround.stopVideoTx =
                        self.frozenWorkaround.logVideoTx =
                        self.frozenWorkaround.frozenStats =
                            false;
                    logger.log('setFrozenWorkaroundConfig', 'disabled on Chrome 109+ for now');
                }
            } else {
                // default is false
                self.frozenWorkaround.stopVideoTx =
                    self.frozenWorkaround.restartVideoRx =
                    self.frozenWorkaround.frozenStats =
                        false;
                self.frozenWorkaround.captureCheck = true;
            }
        }

        // quick stats for video

        function setVideoStatsAddRemove(fid, div, added) {
            if (!self.frozenWorkaround.frozenStats) {
                return;
            }

            var data = self.frozenStats;
            var item = data.items[fid];

            if ((added && item) || (!added && !item)) {
                self.logLayout('setVideoStatsAddRemove fid=' + fid + ' added=' + added + ', ignored');
                return;
            }

            self.logLayout('setVideoStatsAddRemove fid=' + fid + ' added=' + added);

            if (!div) {
                div = $window.$('#videoroom-videos > div[user="' + fid + '"]').get(0);
            }

            if (added) {
                item = self.setVideoStatsStart(fid, div);
            } else {
                self.setVideoStatsState(fid, 'removed');
            }
        }

        function setVideoStatsStart(fid, div) {
            var data = self.frozenStats;
            item = data.items[fid] = {
                state: 'idle',
                playing: false,
                list: [],
                pending: false,
                div: div
            };

            item.interval = $interval(function () {
                self.onVideoStatsInterval(fid);
            }, data.duration);

            if (div && div.hasAttribute('frozen')) {
                div.removeAttribute('frozen');
            }

            return item;
        }

        function setVideoStatsState(fid, value) {
            var data = self.frozenStats;
            var item = data.items[fid];

            if (item && item.state != value) {
                self.logLayout('setVideoStatsState fid=' + fid + ' state=' + item.state + '=>' + value);

                item.state = value;

                if (value == 'playing' || value == 'removed') {
                    delete data.items[fid];
                    if (item.interval) {
                        $interval.cancel(item.interval);
                        item.interval = null;
                    }
                }

                var div = item.div;
                if (!self.pauseOnBackground.paused) {
                    if (value == 'frozen') {
                        if (div && !div.hasAttribute('frozen')) {
                            div.setAttribute('frozen', 'true');
                        }
                    } else if (value != 'frozen') {
                        if (div && div.hasAttribute('frozen')) {
                            div.removeAttribute('frozen');
                        }
                    }
                }
            }
        }

        // called when mute/unmute on the video track.
        function setVideoStatsPlaying(fid, div, value, firstTime, disabled) {
            if (!self.frozenWorkaround.frozenStats) {
                return;
            }
            self.logLayout('setVideoStatsPlaying fid=' + fid + ' value=' + value);

            var data = self.frozenStats;
            if (data.testSuffix && fid && ('' + fid).endsWith(data.testSuffix)) {
                value = false;
            }
            var item = data.items[fid];
            if (!item && (value || disabled)) {
                // TODO: why not (value || firstTime)?
                return;
            }
            if (!item) {
                // add now
                item = self.setVideoStatsStart(fid, div);
            }

            if (item.state == 'idle' && !value) {
                self.setVideoStatsState(fid, 'checking');
            } else if (item.state == 'idle' && value) {
                self.setVideoStatsState(fid, 'playing');
            }
        }

        function setVideoStatsFrozen(fid, div) {
            if (!self.frozenWorkaround.frozenStats) {
                return;
            }

            self.logLayout('setVideoStatsFrozen fid=' + fid);

            var data = self.frozenStats;
            var item = data.items[fid];
            if (!item) {
                if (!div) {
                    div = $window.$('#videoroom-videos > div[user="' + fid + '"]').get(0);
                }

                item = self.setVideoStatsStart(fid, div);
            } else {
                if (!div) {
                    div = item.div;
                }
            }

            self.setVideoStatsState(fid, 'frozen');
        }

        function onVideoStatsInterval(fid) {
            if (!self.frozenWorkaround.frozenStats) {
                return;
            }

            var data = self.frozenStats;
            var item = data.items[fid];
            if (!item || item.pending) {
                return;
            }

            self.logLayout('onVideoStatsInterval - fid=' + fid);

            var remoteFeed = item.div ? item.div.remoteFeed : null;
            item.pending = true;
            self.getReceivedBytesAndFrames(remoteFeed, function (data1) {
                item.pending = false;
                self.logLayout(
                    'onVideoStatsInterval - fid=' + fid + ' state=' + item.state + ' data=' + JSON.stringify(data1)
                );

                if (!data1) {
                    // cleanup interval
                    self.setVideoStatsState(fid, 'removed');
                    return;
                }

                if (data.testSuffix && fid && ('' + fid).endsWith(data.testSuffix)) {
                    data1 = [0, 0];
                }
                self.onVideoStatsVerify(fid, item, data1);
            });
        }

        function onVideoStatsVerify(fid, item, data) {
            var list = item.list;

            var now = Date.now();
            var data1 = { bytes: data[0], frames: data[1], ts: now };
            list.push(data1);
            //console.info('VideoStats ' +  fid + ' ' + JSON.stringify(list));
            if (list.length > 1) {
                var data0 = list[list.length - 2];
                data1.framesDiff = data1.frames - data0.frames;
                data1.bytesDiff = data1.bytes - data0.bytes;

                if (
                    (item.state == 'frozen' || item.state == 'checking' || item.state == 'idle') &&
                    data1.framesDiff > 0 &&
                    data1.bytesDiff > 0
                ) {
                    self.logLayout(
                        'onVideoStatsVerify - playing fid=' +
                            fid +
                            ' frames=' +
                            data1.framesDiff +
                            ' bytes=' +
                            data1.bytesDiff
                    );
                    self.setVideoStatsState(fid, 'playing');
                } else if (
                    (item.state == 'checking' || item.state == 'idle') &&
                    list.length > 2 &&
                    data1.framesDiff == 0 &&
                    data0.framesDiff == 0
                ) {
                    self.logLayout('onVideoStatsVerify - frozen fid=' + fid + ' for two intervals');
                    self.setVideoStatsState(fid, 'frozen');
                }
                if (list.length > 6) {
                    // limit history.
                    list.splice(0, list.length - 6);
                }
            } else {
                self.logLayout('onVideoStatsVerify - added first data fid=' + fid);
            }
        }

        // called on network change event
        function resetVideoStats(reason) {
            if (!self.frozenWorkaround.frozenStats) {
                return;
            }

            self.logLayout('resetVideoStats - reason=' + reason);
            var data = self.frozenStats;
            for (var fid in data.item) {
                self.setVideoStatsState(fid, 'removed');
            }
        }

        // mute to FIR for h264

        function checkMuteToFIR(id, remoteFeed, isMute, disabled) {
            self.removeMuteToFIR(remoteFeed);
            // if muted, capture current bytes and frames decoded, and compare after 6s.
            if (isMute && self.timeoutMuteToFIR && !disabled) {
                self.getReceivedBytesAndFrames(remoteFeed, function (data) {
                    logService.log('videoroomCtrl - before bytes,frames=' + JSON.stringify(data));
                    if (data) {
                        remoteFeed.timerMuteData = data;
                        remoteFeed.timerMuteToFIR = $timeout(function (event) {
                            self.onTimeoutMuteToFIR(id, remoteFeed);
                        }, self.timeoutMuteToFIR);
                    }
                });
            }
        }

        function removeMuteToFIR(remoteFeed) {
            if (remoteFeed && remoteFeed !== true) {
                if (remoteFeed.retryMuteToFIR !== undefined) {
                    delete remoteFeed.retryMuteToFIR;
                }

                // clear the timer
                if (remoteFeed.timerMuteToFIR) {
                    $timeout.cancel(remoteFeed.timerMuteToFIR);
                    delete remoteFeed.timerMuteToFIR;
                }
                // and mute data
                if (remoteFeed.timerMuteData) {
                    delete remoteFeed.timerMuteData;
                }
            }
        }

        function onTimeoutMuteToFIR(id, remoteFeed) {
            delete remoteFeed.timerMuteToFIR;
            self.getReceivedBytesAndFrames(remoteFeed, function (data) {
                logService.log('after bytes,frames=' + JSON.stringify(data));
                if (remoteFeed.timerMuteData && data) {
                    var diffBytes = data[0] - remoteFeed.timerMuteData[0];
                    var diffFrames = data[1] - remoteFeed.timerMuteData[1];
                    if (diffBytes && !diffFrames) {
                        remoteFeed.retryMuteToFIR = (remoteFeed.retryMuteToFIR || 0) + 1;
                        logger.warn(
                            'onTimeoutMuteToFIR',
                            'no frames decoded but bytes received ' +
                                diffBytes +
                                ' in last interval, requesting keyframe; retry=' +
                                remoteFeed.retryMuteToFIR
                        );
                        self.requestKeyFrame(id, true);
                        if (remoteFeed.retryMuteToFIR < self.maxRetryMuteToFIR) {
                            remoteFeed.timerMuteData = data;
                            remoteFeed.timerMuteToFIR = $timeout(function (event) {
                                self.onTimeoutMuteToFIR(id, remoteFeed);
                            }, self.timeoutMuteToFIR);
                        } else {
                            logService.log(
                                'videoroomCtrl stopping retry of mute-to-fir timer, reached retry=' +
                                    remoteFeed.retryMuteToFIR +
                                    ' max=' +
                                    self.maxRetryMuteToFIR
                            );
                        }
                    } else if (!diffBytes && !diffFrames) {
                        logService.log(
                            'videoroomCtrl no frames decoded and no bytes received in last interval, probably a network issue'
                        );
                        delete remoteFeed.retryMuteToFIR;
                    }
                } else {
                    // else no longer pending, ignore
                    delete remoteFeed.retryMuteToFIR;
                }
            });
        }

        // use getStats to get the bytesReceived and framesDecoded values for a peer connection, or null on error.
        function getReceivedBytesAndFrames(remoteFeed, callback) {
            var pc = remoteFeed && remoteFeed.webrtcStuff && remoteFeed.webrtcStuff.pc;
            if (pc && pc.getStats && (!self.layoutPage || self.sendStatsInterval)) {
                pc.getStats(null)
                    .then(function (value) {
                        var sum = [0, 0];
                        value.forEach(function (report) {
                            if (report.type == 'inbound-rtp') {
                                sum[0] += report.bytesReceived || 0;
                                sum[1] += report.framesDecoded || 0;
                            }
                        });
                        callback(sum);
                    })
                    .catch(function (err) {
                        logService.log('videoroomCtrl error in getReceivedBytesAndFrames: ' + err);
                        callback(null);
                    });
            } else {
                logService.log('videoroomCtrl invalid pc in getReceivedBytesAndFrames');
                callback(null);
            }
        }

        function getPeerConnectionStats(pc, statsType, callback) {
            pc.getStats(null)
                .then(function (data) {
                    const stats = Array.from(data.values());

                    let result = undefined;

                    switch (statsType) {
                        case 'audio':
                            result = self.getAudioPeerConnectionStats(stats);
                            break;
                        case 'videoroom':
                        case 'screenshare':
                            result = self.getVideoroomPeerConnectionStats(stats);
                            break;
                        default:
                            logger.warn('getPeerConnectionStats', 'wrong stats type', statsType);
                            break;
                    }

                    if (callback) {
                        callback(result);
                    }
                })
                .catch(function (err) {
                    logger.error('getPeerConnectionStats', 'error in get stats', err);

                    if (callback) {
                        callback(undefined);
                    }
                });
        }

        function canAnalyzeStatsReportMetric(name) {
            return !self.networkState.allowedStatsMetrics || self.networkState.allowedStatsMetrics.includes(name);
        }

        function getAudioPeerConnectionStats(stats) {
            const inboundRtpAudioReport = stats.filter(
                report => report.type === 'inbound-rtp' && report.kind === 'audio'
            );

            return {
                bytesReceived: inboundRtpAudioReport.length === 0 ? undefined : inboundRtpAudioReport[0].bytesReceived
            };
        }

        function getVideoroomPeerConnectionStats(stats) {
            const outboundRtpVideoReport = stats.filter(
                report => report.type === 'outbound-rtp' && report.kind === 'video'
            );
            const framesEncoded = outboundRtpVideoReport
                .map(item => item.framesEncoded)
                .reduce(function (sum, current) {
                    return sum + current;
                }, 0);

            const remoteInboundRtpVideoReport = stats.filter(
                report => report.type === 'remote-inbound-rtp' && report.kind === 'video'
            );

            // Note: there could be no any remote-inbound-rtp report because of network problem, so not use it in that case
            const packetsLost =
                remoteInboundRtpVideoReport.length === 0
                    ? undefined
                    : remoteInboundRtpVideoReport
                          .map(item => item.packetsLost)
                          .reduce(function (sum, current) {
                              return sum + current;
                          }, 0);

            // get max value
            const rtt =
                remoteInboundRtpVideoReport.length === 0
                    ? undefined
                    : remoteInboundRtpVideoReport
                          .map(item => item.roundTripTime)
                          .reduce(function (prev, current) {
                              return Math.max(prev, current);
                          }, 0);

            // Note: if don't find candidate-pair report, then do rejoin
            const candidatePairReport = stats.filter(
                report =>
                    report.type === 'candidate-pair' &&
                    report.state === 'succeeded' &&
                    report.nominated === true &&
                    report.writable === true
            );

            const availableOutgoingBitrate =
                candidatePairReport.length === 0
                    ? undefined
                    : candidatePairReport
                          .map(item => item.availableOutgoingBitrate)
                          .reduce(function (prev, current) {
                              return Math.max(prev, current);
                          }, 0);

            return { framesEncoded, packetsLost, rtt, availableOutgoingBitrate };
        }

        function applyFakePeerConnectionStats(stats, fakeStats) {
            Object.keys(fakeStats).forEach(key => {
                if (fakeStats[key] === -1) {
                    delete fakeStats[key];
                }
            });

            return { ...stats, ...fakeStats };
        }

        function shouldRejoinConference(statsType, prevStats, stats) {
            if (!prevStats || !stats) {
                logger.warn(
                    'shouldRejoinConference',
                    `incomplete stats => can not analyze stats diff (has previous stats: ${!!prevStats}; has new stats: ${!!stats})`,
                    statsType
                );

                return false;
            } else {
                logger.log('shouldRejoinConference', 'analyze stats diff', statsType, prevStats, stats);
            }

            // analyze stats diff
            switch (statsType) {
                case 'audio':
                    if (
                        self.canAnalyzeStatsReportMetric('bytesReceived') &&
                        !self.validateBytesReceived(prevStats, stats)
                    ) {
                        return true;
                    }
                    break;
                case 'videoroom':
                case 'screenshare':
                    if (
                        self.canAnalyzeStatsReportMetric('availableOutgoingBitrate') &&
                        !self.validateAvailableOutgoingBitrate(stats)
                    ) {
                        return true;
                    }

                    if (
                        self.canAnalyzeStatsReportMetric('framesEncoded') &&
                        !self.validateFramesEncoded(prevStats, stats)
                    ) {
                        return true;
                    }

                    if (
                        self.canAnalyzeStatsReportMetric('packetsLost') &&
                        !self.validatePacketsLost(prevStats, stats)
                    ) {
                        return true;
                    }

                    if (self.canAnalyzeStatsReportMetric('rtt') && !self.validateRtt(stats)) {
                        return true;
                    }
                    break;
                default:
                    logger.warn('shouldRejoinConference', 'wrong stats type', statsType);
                    break;
            }

            return false;
        }

        function validateBytesReceived(prevStats, stats) {
            if (prevStats.bytesReceived && stats.bytesReceived) {
                var diffBytesReceived = stats.bytesReceived - prevStats.bytesReceived;
                if (!diffBytesReceived) {
                    logger.log('validateBytesReceived', 'no diff in bytesReceived => should reconnect');

                    return false;
                }
            }

            return true;
        }

        function validateAvailableOutgoingBitrate(stats) {
            if (!stats.availableOutgoingBitrate) {
                logger.log(
                    'validateAvailableOutgoingBitrate',
                    'candidate-pair report is not found => should reconnect'
                );

                return false;
            } else if (stats.availableOutgoingBitrate < self.networkState.availableOutgoingBitrateThreshold) {
                logger.log(
                    'validateAvailableOutgoingBitrate',
                    `availableOutgoingBitrate (${stats.availableOutgoingBitrate}) is less than the threshold value (${self.networkState.availableOutgoingBitrateThreshold}) => should reconnect`
                );

                return false;
            }

            return true;
        }

        function validateFramesEncoded(prevStats, stats) {
            if (prevStats.framesEncoded && stats.framesEncoded) {
                var diffFramesEncoded = stats.framesEncoded - prevStats.framesEncoded;
                if (!diffFramesEncoded) {
                    logger.log('validateFramesEncoded', 'no diff in framesEncoded => should reconnect');

                    return false;
                }
            }

            return true;
        }

        function validatePacketsLost(prevStats, stats) {
            if (prevStats.packetsLost && stats.packetsLost) {
                var diffPacketsLost = stats.packetsLost - prevStats.packetsLost;
                if (diffPacketsLost > self.networkState.packetsLostThreshold) {
                    logger.log(
                        'validatePacketsLost',
                        `packetsLost (${diffPacketsLost}) exceeded the threshold value (${self.networkState.packetsLostThreshold}) => should reconnect`
                    );

                    return false;
                }
            }

            return true;
        }

        function validateRtt(stats) {
            if (stats.rtt) {
                const rtt = stats.rtt * 1000;
                if (rtt > self.networkState.rttThreshold) {
                    logger.log(
                        'validateRtt',
                        `rtt (${rtt}) exceeded the threshold value (${self.networkState.rttThreshold}) => should reconnect`
                    );

                    return false;
                }
            }

            return true;
        }

        // called from stats to check.
        // params have same meaning as in onBrokenMediaPathCheck and caller statsFinalizeResult.
        // Example, type is audio, video or screen; item1 has stats; and
        // interval == interval0 indicates a full interval.
        function onBrokenMediaSourceCheck(type, item1, interval, interval0) {
            if (!self.brokenMediaSource.detect && !self.qualityBarsConfig.enabled) {
                return;
            }

            // for testing, allow setting videoSource and audioSource from internal data structures.
            var audioSource = item1.audioSource,
                videoSource = item1.videoSource;
            if (self.brokenMediaSource.audioSource !== undefined) {
                audioSource = self.brokenMediaSource.audioSource;
            }
            if (self.brokenMediaSource.videoSource !== undefined) {
                videoSource = self.brokenMediaSource.videoSource;
            }

            if (
                interval0 == interval &&
                ((type == 'video' && !videoSource) || (type == 'audio' && !audioSource && !videoSource))
            ) {
                self.brokenMediaSource.detected = true;
                logger.warn(
                    'onBrokenMediaSourceCheck',
                    'broken media source detected type=' +
                        type +
                        ' videoSource=' +
                        item1.videoSource +
                        ' audioSource=' +
                        item1.audioSource
                );
                if (!self.brokenMediaSource.prompted) {
                    self.brokenMediaSource.prompted = true;
                    $timeout(function () {
                        var data = { sfuEvent: true, type: type, audioSource: audioSource, videoSource: videoSource };
                        self.msgflowEvent('broken-media-source', data);
                        analyticsWrapperService.eventTrack(
                            'Meeting - broken media source detected',
                            Object.assign({}, data, { sfuEvent: true, id: self.attendantId })
                        );

                        self.showDeviceInUseAlert(type == 'video' ? 'webcam' : 'microphone and webcam');
                    });
                } // do not prompt again, is already prompted.
            }
        }
    }
]);
